/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon20Solid = forwardRef('ArrowDUturnRightUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M19.566 6.957a1.25 1.25 0 0 1-1.933 1.585L15.75 6.246V11a7.25 7.25 0 0 1-14.5 0V6.5a1.25 1.25 0 0 1 2.5 0V11a4.75 4.75 0 0 0 9.5 0V6.246l-1.883 2.296a1.25 1.25 0 0 1-1.934-1.585l3.134-3.821a2.5 2.5 0 0 1 3.866 0l3.133 3.821Z" })));
});
